<template>
  <div id="locations-candidate">
    <div class="create-profile-step-container">
      <step-title
        :title="title"
        :subtitle="subtitle"
        :icon="icon"
      />
      <div class="field">
        <div class="control is-expanded">
          <div class="field is-inline">
            <input
              id="doNotDisclose"
              v-model="isLocationUndisclosed"
              type="checkbox"
              name="switchOutlinedDefault"
              class="switch is-outlined"
            >
            <label
              class="is-size-6"
              for="doNotDisclose"
            >
              <small>Do not disclose my location.</small>
            </label>
          </div>
        </div>
      </div>
      <div class="field">
        <vue-google-autocomplete
          v-if="$store.state.googleApiLoaded"
          id="placesAutocomplete"
          placeholder="Current Location..."
          :disabled="isLocationUndisclosed"
          :value="currentLocation"
          type="text"
          types="(regions)"
          class="input"
          :existing-place="currentLocation"
          @placechanged="getAddressData"
          @keyup="handleLocationKeypress($event)"
        />
      </div>
      <div class="field">
        <input
          id="exampleCheckbox"
          v-model="isOpenToRelocation"
          class="is-checkradio"
          type="checkbox"
          name="exampleCheckbox"
        >
        <label for="exampleCheckbox">
          <small>I'm open to relocation</small>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import StepTitle from './StepTitle';
import VueGoogleAutocomplete from '@/components/Utilities/VueGoogleAutocomplete';

export default {
  name: 'LocationsCandidate',
  components: {
    StepTitle,
    VueGoogleAutocomplete
  },
  data () {
    return {
      title: 'Location',
      subtitle: 'Tell companies where you want to work.',
      icon: 'fa-map-marker-alt'
    };
  },
  computed: {
    isFormValid () {
      return (
        this.isLocationUndisclosed
        || this.currentLocation !== ''
      );
    },
    isOpenToRelocation: {
      get () {
        return this.$store.state.user.profile.location.open_move;
      },
      set (value) {
        this.$store.commit('EDIT_CANDIDATE_RELOCATION', value);
        this.checkForm();
      }
    },
    currentLocation: {
      get () {
        return this.$store.state.user.profile.location.current;
      },
      set (value) {
        this.$store.commit('EDIT_CANDIDATE_CURRENT_LOCATION', value);
        this.checkForm();
      }
    },
    isLocationUndisclosed: {
      get () {
        return this.$store.state.user.profile.location.undisclosed;
      },
      set (value) {
        this.$store.commit('EDIT_CANDIDATE_UNDISCLOSE_LOCATION', value);
        this.checkForm();
      }
    }
  },
  mounted () {
    this.checkForm();
  },
  methods: {
    getAddressData (addressData, placeResultData, id) {
      let str = placeResultData.formatted_address;
      str = str.substring(0, str.length - 5); // Remove ', USA' on the tail-end of addresses.
      this.$store.commit('EDIT_CANDIDATE_CURRENT_LOCATION', str);
      this.checkForm();
    },
    checkForm () {
      setTimeout(() => {
        this.$emit('checkForm', this.isFormValid);
      }, 50);
    },
    handleLocationKeypress ($event) {
      this.$store.commit('EDIT_CANDIDATE_CURRENT_LOCATION', $event.target.value);
      this.checkForm();
    }
  }
};
</script>

<style scoped lang="scss">
input[type="checkbox"] {
  margin-right: 0.25rem;
}
</style>
